<div #globeContainer class="md:cursor-grab w-full h-full"></div>
